import KeepAlive from 'react-activation';
import { environment } from 'shared/constants/common-meta';
import { createLogger } from 'shared/logger';
import { FeatureLoader, useCacheViewPanelFlag } from '../../featureFlags';
import { CacheViewTypes } from './CacheView.types';

export const CacheView = (props: CacheViewTypes) => {
	const logger = createLogger('CacheView');
	const cacheViewPanelFlag = useCacheViewPanelFlag();
	if (environment.ENABLE_CACHE_VIEW) {
		const key = props.cacheKeyId ? props.cacheKey + '-' + props.cacheKeyId : props.cacheKey;
		logger.log('Mounted:', key);
		return (
			<FeatureLoader>
				{cacheViewPanelFlag?.value ? <KeepAlive name={key} cacheKey={key} children={props.children} /> : props.children}
			</FeatureLoader>
		);
	} else {
		return props.children;
	}
};
